<template lang="">
  <v-main>
    <v-container fluid>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'githubSignup',
  data() {
    return {
      page: 1,
      height: window.innerHeight,
    }
  },
  created: function () {
    this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/login/github')
    .then(response => {
      window.location = response.data.redirect_url
    });
  },
}
</script>
